import React, { useState } from "react"
import ModalCustom from "../../../../../components/ModalCustom"
import imgGenerateReport from "../../../../../images/freemium/generate-report.svg"

export default function ModalFreemium({ handleOk, handleCancel, isVisible }) {
  const [isModalVisible, setIsModalVisible] = useState(false)

  React.useEffect(() => {
    setIsModalVisible(isVisible)
  }, [])

  return (
    <ModalCustom
      modalOpen={isModalVisible}
      showFooter
      onOk={() => handleOk()}
      textButton="Contactar al equipo comercial"
      onCancel={() => handleCancel()}
      width={709}
      textCancelButton="Cerrar">
      <div className="text-left">
        <img
          style={{
            margin: "-21px -24px 20px",
            width: "calc(100% + 48px)",
            minHeight: 432,
          }}
          src={imgGenerateReport}
        />
        <p className="font-size-16">
          <b>
            Lo sentimos, pero no cuentas con acceso para generar reportes 😢
          </b>
        </p>
        <p className="font-size-15">
          En esta sección podrás generar reportes del consolidado de tus
          resultados.
        </p>
        <ul
          className="font-size-15 list-bullet-blue"
          style={{ padding: "0 14px" }}>
          <li>
            Podrás seleccionar el <b>formato</b> de tu preferencial entre{" "}
            <b>Excel y PDF</b>.
          </li>
          <li>
            Podrás elegir entre distintas alternativas de <b>presentación</b>.
          </li>
          <li>
            Podrás <b>personalizar</b> el reporte al seleccionar qué{" "}
            <b>información</b> te gustaría incluir, y qué <b>población</b>{" "}
            dentro de tu organización quisieras considerar.
          </li>
        </ul>
      </div>
    </ModalCustom>
  )
}
